import React from "react";

import {startCase} from "lodash-es";

import * as typography from "@client/shared/typography";
import * as utils from "@client/utils";

import {ManagerTable} from "@client/components/ManagerTable";
import {ManagerLayout} from "@client/site/ManagerLayout";
import * as forms from "@client/site/forms";
import {server} from "@reactivated";

import {ClientNavigation} from "./ClientManagerPlanner";

export const Template = (props: server.manager.templates.ClientCheckInList) => {
    const columns = [{name: "Date", accessor: "date", dataClassName: ""}]
        .concat(
            props.settings.check_in_questions.map((question) => ({
                name: startCase(question.type.toLowerCase()),
                accessor: question.type,
                dataClassName: "",
            })),
        )
        .concat([
            {
                name: "Notes",
                accessor: "notes",
                dataClassName: "w-[300px] whitespace-break-spaces!",
            },
        ]);

    const values = props.check_ins.map((checkIn) =>
        props.settings.check_in_questions.reduce<Record<string, React.ReactNode>>(
            (accumulator, question) => {
                const response = checkIn.responses.find(
                    (r) => r.question.type === question.type,
                );

                return {
                    ...accumulator,
                    [question.type]:
                        response != null
                            ? startCase(response.response.toLowerCase())
                            : "-",
                };
            },
            {
                date: utils.formatDate(checkIn.day.date),
                notes: checkIn.notes,
            },
        ),
    );

    return (
        <ManagerLayout
            title="Check-ins"
            currentClientManagerId={props.client_manager.id}
        >
            <form
                noValidate
                method="POST"
                action=""
                style={{display: "flex", flexDirection: "column", gap: 20}}
            >
                <forms.CSRFToken />
                <ClientNavigation>
                    <typography.Header>Check-ins</typography.Header>
                </ClientNavigation>
                <ManagerTable columns={columns} values={values} />
            </form>
        </ManagerLayout>
    );
};
